/* Footer: mobile menu accordions + newsletter form wording/sizing.
   Moved out of sections/footer.liquid so browsers cache it. The inline version waited for
   DOMContentLoaded; as a deferred script it runs at that same moment. */
(function() {
  // the footer section's id comes from the data-section-id attribute on this script tag
  var SECTION_ID = (document.currentScript && document.currentScript.getAttribute('data-section-id')) || '';
  // Newsletter words come from the language files (window.RynorStrings, written in layout/theme.liquid)
  function word(key, fallback) {
    var value = (window.RynorStrings || {})[key];
    return value && !/translation missing/i.test(value) ? value : fallback;
  }

  function setImportant(el, prop, value) {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function hideDuplicateSubmit(input) {
    if (!input) return;
    input.setAttribute('data-footer-hidden-submit', 'true');
  }

  function styleEmailInput(input) {
    if (!input) return;
    var emailWord = word('newsletter_email', 'E-mail');
    input.placeholder = emailWord;
    input.setAttribute('aria-label', emailWord);
    input.setAttribute('inputmode', 'email');
    input.setAttribute('autocomplete', 'email');
    // sizes + colours come from the --rf-* variables in the footer CSS,
    // so they follow the breakpoints without needing to re-run on resize
    setImportant(input, 'width', '100%');
    setImportant(input, 'height', 'var(--rf-input-h)');
    setImportant(input, 'min-height', 'var(--rf-input-h)');
    setImportant(input, 'max-height', 'var(--rf-input-h)');
    setImportant(input, 'padding', '10px 12.8px');
    setImportant(input, 'border-radius', '0');
    setImportant(input, 'box-shadow', 'none');
    setImportant(input, 'background', 'transparent');
    setImportant(input, 'color', 'var(--rf-text)');
    setImportant(input, 'border', '1px solid var(--rf-input-border)');
    setImportant(input, 'font-size', 'var(--rf-input-fs)');
    setImportant(input, 'line-height', '1.2');
  }

  function styleCTA(button) {
    if (!button) return;

    // label is written in Title Case; the CSS uppercases it on tablet + mobile only
    var buttonWord = word('newsletter_button', 'Get Your Discount');
    if (button.tagName === 'INPUT') {
      button.value = buttonWord;
    } else {
      button.textContent = buttonWord;
    }

    var buttonWrap = button.parentElement;
    if (buttonWrap && buttonWrap.tagName === 'DIV') {
      setImportant(buttonWrap, 'padding-top', '0px');
      setImportant(buttonWrap, 'padding-right', '0px');
      setImportant(buttonWrap, 'padding-bottom', 'var(--rf-btn-wrap-pb)');
      setImportant(buttonWrap, 'padding-left', '0px');
    }

    setImportant(button, 'width', '100%');
    setImportant(button, 'height', 'var(--rf-btn-h)');
    setImportant(button, 'min-height', 'var(--rf-btn-h)');
    setImportant(button, 'max-height', 'var(--rf-btn-h)');
    setImportant(button, 'padding', '0 24px');
    setImportant(button, 'margin-top', '10px');
    setImportant(button, 'border-radius', '0');
    setImportant(button, 'box-shadow', 'none');
    setImportant(button, 'background', 'var(--rf-btn-bg)');
    setImportant(button, 'border', '1px solid var(--rf-btn-bg)');
    setImportant(button, 'color', 'var(--rf-btn-text)');
    setImportant(button, 'font-size', 'var(--rf-btn-fs)');
    setImportant(button, 'font-weight', '400');
    setImportant(button, 'line-height', '1');
    setImportant(button, 'letter-spacing', 'var(--rf-btn-ls)');
    setImportant(button, 'text-transform', 'var(--rf-btn-tt)');
    setImportant(button, 'display', 'flex');
    setImportant(button, 'align-items', 'center');
    setImportant(button, 'justify-content', 'center');
    setImportant(button, 'white-space', 'nowrap');
  }

  function bindAccordion(footer) {
    footer.querySelectorAll('.footer-menu-toggle').forEach(function(btn) {
      if (btn.dataset.boundFooterToggle === 'true') return;
      btn.dataset.boundFooterToggle = 'true';

      var icon = btn.querySelector('.footer-menu-toggle__icon');
      if (icon) icon.textContent = '+';

      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.classList.toggle('is-open', !expanded);

        var currentIcon = btn.querySelector('.footer-menu-toggle__icon');
        if (currentIcon) {
          currentIcon.textContent = expanded ? '+' : '−';
        }
      });
    });
  }

  function syncNewsletter(footer) {
    footer.querySelectorAll('.footer-block__newsletter').forEach(function(newsletter) {
      // the heading is printed (and translated) by sections/footer.liquid, so it's left as is

      var subheading = newsletter.querySelector('.rte');
      if (subheading) {
        subheading.style.display = 'none';
      }

      var formWrap = newsletter.querySelector('.footer-block__newsletter-form');
      if (!formWrap) return;

      var emailInput = formWrap.querySelector('input[type="email"], input[name*="email"], input[id*="email"]');
      if (emailInput) {
        styleEmailInput(emailInput);
      }

      var visibleButton = formWrap.querySelector('button, input[type="button"]');
      var submitInput = formWrap.querySelector('input[type="submit"]');

      if (visibleButton) {
        styleCTA(visibleButton);
        if (submitInput) {
          hideDuplicateSubmit(submitInput);
        }
      } else if (submitInput) {
        styleCTA(submitInput);
      }

      formWrap.querySelectorAll('label').forEach(function(label) {
        label.style.display = 'none';
      });
    });
  }

  function initFooter() {
    var footer = document.querySelector('[data-section-id="' + SECTION_ID + '"]');
    if (!footer) return;

    bindAccordion(footer);
    syncNewsletter(footer);

    var tries = 0;
    var timer = setInterval(function() {
      tries += 1;
      syncNewsletter(footer);
      if (tries >= 18) {
        clearInterval(timer);
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
  } else {
    initFooter();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail && event.detail.sectionId === SECTION_ID) {
      initFooter();
    }
  });

})();
